// extracted by mini-css-extract-plugin
module.exports = {"flight-order-card":"FlightOrderCard_flight-order-card__8HF9e"};